export function scrollChatToBottom() {
  const chatArea = document.getElementById('chat')
  if (chatArea) {
    chatArea.scrollTop = chatArea.scrollHeight
  }
}
